import {useAppState} from 'store/utils';

export function useSettingsView(): SettingsViewState {
  return useAppState().settingsView;
}
